/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2025, Zumper
 */

export const getInteractionTargetElementSelector = (
  interactionTargetElement: Node | null | undefined
) => {
  const el = [
    ...(interactionTargetElement?.parentElement?.children ?? []),
  ].find((e) => e === interactionTargetElement)
  const closestInteractionElement = el?.closest(
    'button, a, input, textarea, select'
  )
  const target = closestInteractionElement ?? el
  if (!target) {
    return ''
  }
  return getSelectorWithAncestors(target)
}

function getSelector(element: Element): string {
  const type = element.tagName.toLowerCase()
  const classes = element.className
  const id = element.id
  return `${type}${id ? `#${id}` : ''}${
    classes ? `.${classes.split(' ').join('.')}` : ''
  }`
}

function getSelectorWithAncestors(element: Element, currentDepth = 0): string {
  const selector = getSelector(element)
  if (currentDepth < 2 && element.parentElement) {
    return `${getSelectorWithAncestors(
      element.parentElement,
      currentDepth + 1
    )} > ${selector}`
  }
  return selector
}
